import React, { Fragment, useContext } from "react";
import { scheduleState } from "bodycodi/cmap/app/js/common";
import empty from "bodycodi/cmap/app/img/member-profile-empty.png";
import { DispatchContext } from "bodycodi/cmap/app/components/common/context";
import { DispatchContext as HomeDispatchContext } from "bodycodi/cmap/app/components/cmap2010/home";

interface ClassMemberList {
  isWatingMember: boolean;
  isLimit: boolean;
  isSeatClass: boolean;
  reservationLimitNo: number;
  classMemberList: any[];
  clickedMembers: any[];
  onClickMember: (v: any) => void;
}

const scheduleStateObj: { [key: string]: string } = {
  R: "blue",
  E: "green",
  A: "red",
  W: "gray",
  O: "purple",
};

const ClassMemberList = ({
  isWatingMember,
  isLimit,
  isSeatClass,
  reservationLimitNo,
  classMemberList,
  clickedMembers = [],
  onClickMember,
}: ClassMemberList) => {
  const { dispatch } = useContext(DispatchContext);
  const { dispatch: homeDispatch } = useContext(HomeDispatchContext);
  const cntAbsentMembers = classMemberList.filter((v) => v.scheduleState === "A").length;

  const handleClickUserDtl = (e: any, seqMember: number) => {
    e.stopPropagation();
    homeDispatch({
      type: "UPDATE",
      data: {
        memberDtlPopData: {
          seqMember,
        },
      },
    });
    dispatch({ type: "POP_UP_OPEN", id: "MEMBER_DTL_POP", open: { memberDtlPop: true } });
  };

  return (
    <div className="rsrv-member-list">
      {classMemberList.map((v: any, i: number) => {
        const isIncludeMember = clickedMembers.some((m) => m.seqMember === v.seqMember);
        if (i > 15 && isLimit) {
          // isLimit 이면 16명까지만 보여줌
          return <Fragment key={i}></Fragment>;
        }
        return (
          <div
            key={v.seqMember}
            className={`rsrv-member ${isIncludeMember && "active"} ${isWatingMember && "margin"}`}
            onClick={() => onClickMember(v)}
          >
            <div className="profile">
              <img src={v.imgUrl || empty} />
              {v.entranceMemberYn === "Y" && <div className="active"></div>}
            </div>
            <div className="name">{v.name}</div>
            {isWatingMember ? (
              <div className="union gray">대기 {i + 1}</div>
            ) : (
              <div className={"union " + scheduleStateObj[v.scheduleState]}>
                {v.scheduleState === "R" &&
                  `${
                    isSeatClass && v.seatNo === 0
                      ? "좌석 미지정"
                      : `${scheduleState(v.scheduleState)} ${isSeatClass ? v.seatNo : i + 1}`
                  }`}
                {v.scheduleState !== "R" && `${scheduleState(v.scheduleState)} -${v.lessonAmount}`}
              </div>
            )}
            {v.seqMember === 0 && v.naverBookingY ? (
              <div className="user-dtl naver" onClick={(e) => e.stopPropagation()}>
                네이버 예약
              </div>
            ) : (
              <div className="user-dtl" onClick={(e) => handleClickUserDtl(e, v.seqMember)}>
                +더보기
              </div>
            )}
          </div>
        );
      })}

      {/* 예약인원 외 나머지 빈자리 */}
      {/* 일반보기 나머지, 수업정원+결석회원이 16명 이하*/}
      {isLimit &&
        reservationLimitNo + cntAbsentMembers > classMemberList.length &&
        reservationLimitNo + cntAbsentMembers <= 16 &&
        [...Array(reservationLimitNo + cntAbsentMembers - classMemberList.length)].map(
          (v: any, i: number) => (
            <div key={i} className="rsrv-member">
              <div className="profile">
                <div className="empty-seat"></div>
              </div>
              <div className="name">공석</div>
              <div className="union gray">예약 {i + 1 + classMemberList.length}</div>
              <div className="user-dtl invisible"></div>
            </div>
          )
        )}
      {/* 일반보기 나머지, 수업정원+결석회원이 16명 초과*/}
      {isLimit &&
        reservationLimitNo + cntAbsentMembers > classMemberList.length &&
        reservationLimitNo + cntAbsentMembers > 16 &&
        [...Array(16 - classMemberList.length > 0 ? 16 - classMemberList.length : 0)].map(
          (v: any, i: number) => (
            <div key={i} className="rsrv-member">
              <div className="profile">
                <div className="empty-seat"></div>
              </div>
              <div className="name">공석</div>
              <div className="union gray">예약 {i + 1 + classMemberList.length}</div>
              <div className="user-dtl invisible"></div>
            </div>
          )
        )}
      {/* 전체보기 */}
      {!isWatingMember &&
        !isLimit &&
        [...Array(reservationLimitNo + cntAbsentMembers - classMemberList.length)].map(
          (v: any, i: number) => (
            <div key={i} className="rsrv-member">
              <div className="profile">
                <div className="empty-seat"></div>
              </div>
              <div className="name">공석</div>
              <div className="union gray">예약 {i + 1 + classMemberList.length}</div>
              <div className="user-dtl invisible"></div>
            </div>
          )
        )}
    </div>
  );
};

export default ClassMemberList;
